var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 6.667H1.334V3.333h3.333V5m0 1.667 2.667 4m-2.667-4V5m2.667 5.667h3.333V14H7.334v-3.333zM4.667 5h6.667m0 0v1.667h3.333V3.333h-3.333V5z",
    stroke: "#fff",
    strokeWidth: 1.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteWhite);
export default __webpack_public_path__ + "static/media/siteWhite.d420841523eb9179e6a8fcf78d4d4399.svg";
export { ForwardRef as ReactComponent };